
import Vue from "vue"
const filterList = require.context("./src", true, /\.js$/)
filterList.keys().forEach(fileName => {
  const file = filterList(fileName)
  for (const key in file) {
    Vue.filter(key, file[key])
  }
})